import EmailListItemContainer from './EmailListItemContainer';

export default EmailListItemContainer;
